export const sidenote__type: Record<string, string> = {
  0: "Reference",
  1: "Explainer",
}
